export default __webpack_public_path__ + "static/media/cardimage3.1b8e228d.png";